/**
 * FAQ accordion — single-open behavior.
 * If the parent has [data-faq-single-open], opening one <details> closes others.
 */
(function() {
  document.querySelectorAll('[data-faq-single-open]').forEach(group => {
    const items = group.querySelectorAll('details');
    items.forEach(d => {
      d.addEventListener('toggle', () => {
        if (d.open) {
          items.forEach(other => { if (other !== d) other.open = false; });
        }
      });
    });
  });
})();
